<template>
  <div class="mega-menu-shell" ref="megamenu">
    <div class="mega-menu-shell--content">
      <nav class="main-navigation">
        <ul class="router-navigation">
          <li class="nav-item">
            <router-link to="/"
              ><IndexTitle
                text="Home"
                index="01"
                caption="An introductory to my portfolio"
            /></router-link>
          </li>
          <li class="nav-item">
            <router-link
              to="/projects"
              :class="{ 'active-route': $route.path == '/about' }"
              ><IndexTitle
                text="Projects"
                index="02"
                caption="A showcase of what I create through previous experiences and collaborations"
            /></router-link>
          </li>
          <!-- <li class="nav-item">
						<router-link to="/sandbox"
							><IndexTitle
								text="Sandbox"
								index="03"
								caption="A collectio[N] of random & fun projects I want to archive"
						/></router-link>
					</li> -->
          <li class="nav-item">
            <router-link to="/about"
              ><IndexTitle
                text="About"
                index="03"
                caption="A bit about myself as well as my process, skills, and experiences"
            /></router-link>
          </li>
        </ul>
        <div class="contact-navigation nav-item">
          <span class="contact-navigation__index">04</span>
          <ul>
            <li>
              <a href="mailto:hello@lucasmccallum.com"
                >hello@lucasmccallum.com</a
              >
            </li>
            <li>
              <a
                target="_blank"
                href="https://ca.linkedin.com/in/lucasmccallummedia"
                >LinkedIn</a
              >
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import IndexTitle from "@/components/IndexTitle";
export default {
  name: "MegaMenu",
  data() {
    return {
      menuTl: null,
    };
  },
  props: {
    menuActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    IndexTitle,
  },
};
</script>
